import { requireAuth } from '@/functions';
import ProductsHome from '@/views/products/products.view.vue';
import { RouteConfig } from 'vue-router';

export const productsRouter: Array<RouteConfig> = [
  {
    path: '/produtos',
    name: 'products',
    component: ProductsHome,
    beforeEnter: requireAuth,
  },
];
